const MONTACARGAS_SCOPE = "/montacargas";

export function isMontacargasRoute(pathname = window.location.pathname) {
  return pathname === MONTACARGAS_SCOPE || pathname.startsWith(`${MONTACARGAS_SCOPE}/`);
}

// Se llama una sola vez, antes del render, desde src/index.js.
// Si no estamos en /montacargas no hace nada: el resto de la app sigue
// funcionando exactamente igual (sin manifest dinámico, sin service worker).
export function registerMontacargasPwa() {
  if (!isMontacargasRoute()) return;

  // El index.html solo trae un <link rel="manifest">; lo reapuntamos al
  // manifest de montacargas en vez de agregar uno nuevo (los navegadores
  // solo respetan de forma confiable el primero que encuentran).
  const manifestLink = document.querySelector('link[rel="manifest"]');
  if (manifestLink) {
    manifestLink.setAttribute("href", "/montacargas/manifest.json");
  }

  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register("/montacargas/sw.js", { scope: `${MONTACARGAS_SCOPE}/` })
      .catch((error) => {
        console.error("[montacargas] No se pudo registrar el service worker", error);
      });
  }
}
